// Theme constants for public maintenance tracking view
export const statusColors = {
  planned: { main: '#f59e0b', bg: '#fef3c7' },      // Orange/amber
  in_progress: { main: '#3b82f6', bg: '#dbeafe' },  // Blue
  completed: { main: '#10b981', bg: '#d1fae5' },    // Green
  picked_up: { main: '#8b5cf6', bg: '#ede9fe' },    // Purple
  cancelled: { main: '#ef4444', bg: '#fee2e2' },    // Red
  waiting: { main: '#ed8936', bg: '#fef3e2' },  // Orange
  vehicle_in_workshop: { main: '#0d9488', bg: '#ccfbf1' }, // Teal
};

export const theme = {
  colors: {
    primary: '#1a365d',
    primaryLight: '#2d4a6f',
    accent: '#3182ce',
    accentLight: '#4299e1',
    background: '#f8fafc',
    surface: '#ffffff',
    surfaceHover: '#f1f5f9',
    text: '#1e293b',
    textMuted: '#64748b',
    textLight: '#94a3b8',
    border: '#e2e8f0',
    borderLight: '#f1f5f9',
    success: '#10b981',
    successBg: '#d1fae5',
  },
  fonts: {
    primary: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  shadows: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)',
    lg: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
  },
  radius: { sm: '4px', md: '8px', lg: '12px', xl: '16px', full: '9999px' }
};

export const getStatusColor = (status) => {
  return statusColors[status] || statusColors.planned;
};

export const statusSteps = [
  { key: 'planned', labelKey: 'status_planned' },
  { key: 'in_progress', labelKey: 'status_in_progress' },
  { key: 'completed', labelKey: 'status_completed' },
  { key: 'picked_up', labelKey: 'status_picked_up' },
];

export const getStatusIndex = (status) => {
  // Map side states to their nearest main state position
  if (status === 'waiting') return statusSteps.findIndex(s => s.key === 'in_progress');
  if (status === 'vehicle_in_workshop') return statusSteps.findIndex(s => s.key === 'planned');
  return statusSteps.findIndex(s => s.key === status);
};
